/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from '@apollo/client';
import React from 'react';
import ProductsList from '../products-list';
import { IssueType } from '../../helpers/stock-level-issue-messages';
import query from './query.graphql'; // eg;
// "2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383?"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383?foo=bar"

import { jsx as _jsx } from "react/jsx-runtime";
const urlProductIdRegex = /^\/?(\d+)\/([-0-9a-zA-Z]+)\/?(\?.*)?$/;

const parseUrlProductId = str => {
  // prettier-ignore
  const [// Skip the full string match
  , shop, id] = urlProductIdRegex.exec(str) || [];
  return {
    id,
    shop: Number(shop)
  };
};

export function aggregateIssues(variantIssues) {
  if (!variantIssues.every(issues => issues.length > 0)) {
    return [];
  }

  const uniqueIssues = [...new Map(variantIssues.flat().map(issue => [issue.type, issue])).values()];
  const stockRelatedIssues = uniqueIssues.filter(issue => [IssueType.LowStock, IssueType.OutOfStock].indexOf(issue.type) >= 0);

  if (stockRelatedIssues.every(issue => issue.type === IssueType.OutOfStock)) {
    return uniqueIssues;
  }

  return uniqueIssues.filter(issue => issue.type !== IssueType.OutOfStock);
}

const convertProduct = product => {
  var _firstVariant$images, _firstVariant$images$;

  const [variant, ...otherVariants] = product.variants.map(variant => {
    var _variant$discountPric;

    return {
      price: {
        originalPrice: variant.originalPrice,
        discountedPrice: variant.discountPrice,
        effectivePrice: (_variant$discountPric = variant.discountPrice) !== null && _variant$discountPric !== void 0 ? _variant$discountPric : variant.originalPrice
      }
    };
  });
  const firstVariant = product.variants[0];
  return {
    brand: firstVariant.brand,
    variantGroupCode: firstVariant.variantGroupCode,
    otherVariants,
    variant,
    shop: product.shop,
    image: (_firstVariant$images = firstVariant.images) === null || _firstVariant$images === void 0 ? void 0 : (_firstVariant$images$ = _firstVariant$images[0]) === null || _firstVariant$images$ === void 0 ? void 0 : _firstVariant$images$.url,
    name: product.title,
    issues: aggregateIssues(product.variants.map(variant => variant.issues))
  };
};

export const ProductsInMarkdown = ({
  ids = ''
}) => {
  const {
    loading,
    error,
    data
  } = useQuery(query, {
    errorPolicy: 'ignore',
    context: {
      version: 2
    },
    variables: {
      ids: ids.split(',').map(parseUrlProductId).filter(({
        id,
        shop
      }) => id && shop)
    },
    skip: false
  });

  if (loading) {
    // TODO: Loading spinner / skeleton?
    return null;
  }

  if (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return null;
  }

  const {
    products = []
  } = data || {};
  const convertedProducts = products.reduce((acc, product) => {
    const hasVariants = product && product.variants.length > 0;

    if (!hasVariants) {
      return acc;
    } // In a try-catch because we don't have proper types here and there are a
    // number of potentially risky assumptions when converting the product


    try {
      acc.push(convertProduct(product));
    } catch (e) {
      console.error(e);
    }

    return acc;
  }, []);
  return /*#__PURE__*/_jsx(ProductsList, {
    products: convertedProducts,
    page: 0,
    itemsPerPage: 8,
    basePath: ""
  });
};